﻿const isBase64 = (value: string) => {
    try {
        return btoa(atob(value)) === value;
    } catch {
        return false;
    }
};

export default isBase64;
